export default __webpack_public_path__ + "images/61a9ae23ada0c516111e887f7e3cc10b.png";